<script>
import Vue from 'vue'
Vue.component('tabs', {
  template: `
    <div>
      <div class="tabs mb-3">
        <ul class="nav nav-tabs">
          <li v-for="tab in tabs" :class="{ 'active': tab.isActive, 'nav-item': true }">
            <a :href.prevent="tab.href" @click.prevent="selectTab(tab)" class="nav-link">{{ tab.name }}</a>
          </li>
        </ul>
      </div>

      <div class="tabs-details">
        <slot></slot>
      </div>
    </div>
  `,
  data() {
    return { tabs: [] }
  },
  created() {
    this.tabs = this.$children;
  },
  methods: {
    selectTab: function(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = (tab.name == selectedTab.name);
      });
    }
  }
});

Vue.component('tab', {
  props: {
    name: { required: true },
    selected: { default: false }
  },
  template: `<div v-show="isActive"><slot></slot></div>`,
  data() {
    return { isActive: false }
  },
  computed: {
    href() {
      return '#' + this.name.toLowerCase().replace(/ /g , '-');
    }
  },
  mounted() {
    this.isActive = this.selected;
  }
});

export default {
  tabs: Vue.component('tabs'),
  tab: Vue.component('tab')
}

</script>



// WEBPACK FOOTER //
// src/components/tabs/tabs.vue